import moment from 'moment'

export default function (d) {
  return moment(d).format('HH:mm')
}



// WEBPACK FOOTER //
// ./src/utils/timeFormatter.js